// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/close.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/menu_white.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/images/menu_blue.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-wrap {
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 100;
}
.header-wrap.white {
    box-shadow: 0 0.02604rem 0.05208rem rgba(0, 0, 0, .1);
    background: #fff;
}
.header {
    /* height: 100px; */
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.header-logo {
    margin-left: 0.3125rem;
}
.header-logo-img {
    /* margin-top: 27px; */
    width: 0.875rem;
    height: 0.23958rem;
    vertical-align:middle;
}
.header-nav {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    color: rgba(255, 255, 255, .7);
}
.header-nav-item {
    line-height: 0.52083rem;
    font-size: 0.10417rem;
    cursor: pointer;
    padding-right: 0.26042rem;
}
.white .header-nav {
    color: #6F7783;
}
.header-nav-item:hover {
 color: #fff;
}
.white .header-nav-item:hover {
 color: #2475EE;
}
.header-toggler {
    display: none;
}
.header-toggler-icon {
    display: none;
}
.close-icon {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    width: 0.46875rem;
    height: 0.46875rem;
    background-repeat: no-repeat;
    background-size: contain;
    position:absolute;
    top: 0.15625rem;
    right: 0.15625rem;
}

@media screen and (max-width: 700px) {
    .header {
        position: relative;
    }
    .header-logo-img {
        width: 1.5rem;
        height: 0.8125rem;
    }
    .header-nav {
        display: none;
    }
    .header-toggler {
        display: none;
        transition: all 1s ease;
    }
    .header-toggler.visible {
        display: block;
        position: absolute;
        top: 0;
        width: 100%;
        background-color: #fff;
    }
    .header-toggler .header-logo {
        display: flex;
        margin-top: 0.14583rem;
        padding-top: 0;
    }
    .header-toggler-icon {
        display: block;
        width: 0.46875rem;
        height: 0.46875rem;
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
        background-repeat: no-repeat;
        background-size: contain;
        margin-right: 0.26042rem;
    }
    .header-toggler-icon.blue {
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    }
    .header-toggler-box {
        background-color: #fff;
        width: 100%;
        box-shadow:0.05208rem 0.05208rem 0.05208rem rgba(0, 0, 0, .1)
    }
    .header-toggler-box .header-nav-item {
        padding: 0.20833rem 0;
        font-size: 0.29167rem;
    }
    .header-toggler-box .header-nav-item:hover {
        background-color: rgba(0, 0, 0, .1);
    }
}

@media screen and (max-width: 340px) {
    .header {
        height: 1.04167rem;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Header/Header.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAQ;IACR,WAAW;IACX,YAAY;AAChB;AACA;IACI,qDAA0C;IAC1C,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,sBAAiB;AACrB;AACA;IACI,sBAAsB;IACtB,eAAY;IACZ,kBAAY;IACZ,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,iBAAiB;IACjB,8BAA8B;IAC9B,8BAA8B;AAClC;AACA;IACI,uBAAkB;IAClB,qBAAe;IACf,eAAe;IACf,yBAAmB;AACvB;AACA;IACI,cAAc;AAClB;AACA;CACC,WAAW;AACZ;AACA;CACC,cAAc;AACf;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,mDAAgD;IAChD,iBAAW;IACX,kBAAY;IACZ,4BAA4B;IAC5B,wBAAwB;IACxB,iBAAiB;IACjB,eAAS;IACT,iBAAW;AACf;;AAEA;IACI;QACI,kBAAkB;IACtB;IACA;QACI,aAAY;QACZ,iBAAa;IACjB;IACA;QACI,aAAa;IACjB;IACA;QACI,aAAa;QACb,uBAAuB;IAC3B;IACA;QACI,cAAc;QACd,kBAAkB;QAClB,MAAQ;QACR,WAAW;QACX,sBAAsB;IAC1B;IACA;QACI,aAAa;QACb,sBAAgB;QAChB,cAAgB;IACpB;IACA;QACI,cAAc;QACd,iBAAW;QACX,kBAAY;QACZ,yDAA2D;QAC3D,4BAA4B;QAC5B,wBAAwB;QACxB,wBAAkB;IACtB;IACA;QACI,yDAA0D;IAC9D;IACA;QACI,sBAAsB;QACtB,WAAW;QACX;IACJ;IACA;QACI,qBAAiB;QACjB,qBAAe;IACnB;IACA;QACI,mCAAmC;IACvC;AACJ;;AAEA;IACI;QACI,kBAAa;IACjB;AACJ","sourcesContent":[".header-wrap {\n    position: fixed;\n    top: 0px;\n    width: 100%;\n    z-index: 100;\n}\n.header-wrap.white {\n    box-shadow: 0px 5px 10px rgba(0, 0, 0, .1);\n    background: #fff;\n}\n.header {\n    /* height: 100px; */\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n.header-logo {\n    margin-left: 60px;\n}\n.header-logo-img {\n    /* margin-top: 27px; */\n    width: 168px;\n    height: 46px;\n    vertical-align:middle;\n}\n.header-nav {\n    display: flex;\n    flex-wrap: nowrap;\n    justify-content: space-between;\n    color: rgba(255, 255, 255, .7);\n}\n.header-nav-item {\n    line-height: 100px;\n    font-size: 20px;\n    cursor: pointer;\n    padding-right: 50px;\n}\n.white .header-nav {\n    color: #6F7783;\n}\n.header-nav-item:hover {\n color: #fff;\n}\n.white .header-nav-item:hover {\n color: #2475EE;\n}\n.header-toggler {\n    display: none;\n}\n.header-toggler-icon {\n    display: none;\n}\n.close-icon {\n    background: url('../../assets/images/close.svg');\n    width: 90px;\n    height: 90px;\n    background-repeat: no-repeat;\n    background-size: contain;\n    position:absolute;\n    top: 30px;\n    right: 30px;\n}\n\n@media screen and (max-width: 700px) {\n    .header {\n        position: relative;\n    }\n    .header-logo-img {\n        width: 288px;\n        height: 156px;\n    }\n    .header-nav {\n        display: none;\n    }\n    .header-toggler {\n        display: none;\n        transition: all 1s ease;\n    }\n    .header-toggler.visible {\n        display: block;\n        position: absolute;\n        top: 0px;\n        width: 100%;\n        background-color: #fff;\n    }\n    .header-toggler .header-logo {\n        display: flex;\n        margin-top: 28px;\n        padding-top: 0px;\n    }\n    .header-toggler-icon {\n        display: block;\n        width: 90px;\n        height: 90px;\n        background-image: url('../../assets/images/menu_white.svg');\n        background-repeat: no-repeat;\n        background-size: contain;\n        margin-right: 50px;\n    }\n    .header-toggler-icon.blue {\n        background-image: url('../../assets/images/menu_blue.svg');\n    }\n    .header-toggler-box {\n        background-color: #fff;\n        width: 100%;\n        box-shadow:10px 10px 10px rgba(0, 0, 0, .1)\n    }\n    .header-toggler-box .header-nav-item {\n        padding: 40px 0px;\n        font-size: 56px;\n    }\n    .header-toggler-box .header-nav-item:hover {\n        background-color: rgba(0, 0, 0, .1);\n    }\n}\n\n@media screen and (max-width: 340px) {\n    .header {\n        height: 200px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
